export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login'),
    meta: {
      title: '登录中'
    }
  },
  {
    path: '/raxwLogin',
    name: 'raxwLogin',
    component: () => import('../views/raxwLogin'),
    meta: {
      title: '登录中'
    }
  },
  {
    path: '/building',
    name: 'building',
    component: () => import('../views/iphone/building'),
    meta: {
      title: '闭馆公告'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/iphone/index'),
    meta: {
      title: '国旗教育馆票务预约'
    }
  },
  {
    path: '/myAppointed',
    name: 'myAppointed',
    component: () => import('../views/iphone/myAppointed'),
    meta: {
      title: '我的预约'
    }
  },
  {
    path: '/QRCode',
    name: 'QRCode',
    component: () => import('../views/iphone/QRCode'),
    meta: {
      title: '核销二维码'
    }
  },
  {
    path: '/ipadLogin',
    name: 'ipadLogin',
    component: () => import('../views/ipad/login'),
    meta: {
      title: '访客预约核销'
    }
  },
  {
    path: '/ipadIndex',
    name: 'ipadIndex',
    component: () => import('../views/ipad/index'),
    meta: {
      title: '访客预约核销'
    }
  },
  {
    path: '/writeOffList',
    name: 'writeOffList',
    component: () => import('../views/ipad/writeOffList'),
    meta: {
      title: '核销列表',
      needToken: true
    }
  },
  {
    path: '/writeOffDetail',
    name: 'writeOffDetail',
    component: () => import('../views/ipad/writeOffDetail'),
    meta: {
      title: '核销详情',
      needToken: true
    }
  }
];
